module.exports = __webpack_public_path__ + "img/32.bae0609d.jpg";